module.exports = __webpack_public_path__ + "static/media/www.stayincostarica.com.f37e1145.jpg";